import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import CookieConsent from './components/CookieConsent';
import Layout from './components/Layout';
import Home from './pages/Home';
import Page from './pages/Page';
import DocumentsPage from './pages/DocumentsPage';
import SharedDocumentPage from './pages/SharedDocumentPage';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UsersManager from './components/UsersManager';
import DocumentsManager from './components/DocumentsManager';
import NewsManager from './components/NewsManager';
import BoardManager from './components/BoardManager';
import FunktionarerManager from './components/FunktionarerManager';
import ContactEntriesManager from './components/ContactEntriesManager';
import ProfileManager from './components/ProfileManager';
import BackupRestoreManager from './components/BackupRestoreManager';
import DashboardLayout from './components/DashboardLayout';
import PagesEditor from './components/PagesEditor';
import MatrikelManager from './components/MatrikelManager';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);

  return (
    <>
      <ScrollToTop />
      <CookieConsent />
      <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />

        {/* Subpages */}
        <Route path="foreningen/:slug" element={<Page category="foreningen" />} />
        <Route path="ansvarsomraden/:slug" element={<Page category="ansvarsomraden" />} />
        <Route path="nedingen/:slug" element={<Page category="nedingen" />} />
        <Route path="dokument" element={<DocumentsPage />} />
        <Route path="d/:token" element={<SharedDocumentPage />} />

        {/* Auth */}
        <Route path="styrelsen" element={<Login />} />
        <Route path="styrelsen/dashboard/*" element={
          <ProtectedRoute minimumRole="readOnly">
            <DashboardLayout />
          </ProtectedRoute>
        }>
          <Route index element={<Dashboard />} />
          <Route path="profile" element={<ProfileManager />} />
          <Route path="pages" element={<PagesEditor />} />
          <Route path="pages/:category/:slug" element={<PagesEditor />} />
          <Route path="news" element={<NewsManager />} />
          <Route path="documents" element={<DocumentsManager />} />
          <Route path="board" element={<BoardManager />} />
          <Route path="funktionarer" element={<FunktionarerManager />} />
          <Route path="contact" element={<ContactEntriesManager />} />
          <Route path="users" element={<UsersManager />} />
          <Route path="matrikel" element={<MatrikelManager />} />
          <Route path="backup" element={
            <ProtectedRoute minimumRole="admin">
              <BackupRestoreManager />
            </ProtectedRoute>
          } />
        </Route>

        {/* 404 */}
        <Route path="*" element={
          <div style={{ padding: '3rem', textAlign: 'center' }}>
            <h2>Sidan hittades inte</h2>
            <p>Sidan du söker finns inte.</p>
          </div>
        } />
      </Route>
    </Routes>
    </>
  );
}

export default App;
